<div class="trip-detail-popup-right">
  <img
    src="assets/img/icons8-macos-close-60.png"
    class="close-icons"
    (click)="close()"
  />
</div>
<form class="admin-forms" [formGroup]="doTruckOwnerForm">
  <div class="accordion-class">
    <h5>DO to Truck Owner</h5>
    <mat-divider></mat-divider>
  </div>
  <div class="input-fileds-container">
    <div class="group driver-truck">
      <div class="row align-items-center mtb">
        <div class="col-sm-3">
          <mat-label>Work Order No</mat-label>
        </div>
        <div class="col-sm-3">
          <mat-form-field
            class="flex-gt-sm example-full-width truck-type-input"
          >
            <input
              matInput
              [value]="work_order_msg"
              placeholder="Work Order No"
              readonly
            />
          </mat-form-field>
        </div>

        <div class="col-sm-3">
          <mat-label>Actual Price Per Ton</mat-label>
        </div>
        <div class="col-sm-3">
          <mat-form-field>
            <input
              matInput
              formControlName="act_ton"
              placeholder="Price Per Ton"
              required
              readonly
            />
            <mat-error>Please Enter Actual Price</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row align-items-center mtb">
        <div class="col-sm-3">
          <mat-label>Work Order Date</mat-label>
        </div>
        <div class="col-sm-3">
          <mat-form-field>
            <input
              matInput
              formControlName="work_date"
              placeholder="DD-MM-YYYY"
              readonly
              required
            />
            <mat-error>Please Enter Work Order Date</mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-3">
          <mat-label>Work Order QTY</mat-label>
        </div>
        <div class="col-sm-2">
          <mat-form-field>
            <input
              matInput
              formControlName="total_tons"
              placeholder="WO Qty"
              readonly
            />
          </mat-form-field>
        </div>
        <div class="col-sm-1">
          <p class="tons">Tons</p>
        </div>
      </div>
      <div class="row align-items-center mtb">
        <div class="col-sm-3">
          <mat-label>Remaining Tons</mat-label>
        </div>
        <div class="col-sm-3">
          <mat-form-field>
            <input
              matInput
              formControlName="remaining_tons"
              readonly
              placeholder="Remaining Tons"
            />
          </mat-form-field>
        </div>
      </div>
      <mat-divider class="divider_mat"></mat-divider>
      <div class="row align-items-center mtb">
        <div class="col-sm-12">
          <h6>DO Details</h6>
        </div>
      </div>
      <div class="row align-items-center mtb">
        <div class="col-sm-3">
          <mat-label>Do Issued Date:</mat-label>
        </div>
        <div class="col-sm-3">
          <mat-form-field>
            <mat-datepicker #picker1></mat-datepicker>
            <input
              matInput
              [matDatepicker]="picker1"
              placeholder="DD-MM-YYYY"
              [min]="minDate"
              formControlName="do_issue_date"
              (click)="picker1.open()"
            />
            <mat-error>Please Enter Trip Booking Date </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row align-items-center mtb" F>
        <div class="col-sm-3">
          <mat-label>Truck Owner Name:</mat-label>
        </div>
        <div class="col-sm-3">
          <mat-form-field
            class="flex-gt-sm example-full-width truck-type-input"
          >
            <mat-select
              dropLocationSearchField
              formControlName="truckowner_id"
              placeholder="Select Truck Owner Name"
              required
            >
              <mat-option
                *ngFor="let item of truckownerArray"
                [value]="item._id"
                (click)="selectChangeHandlerTruck(item)"
              >
                {{ item.username }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-sm-3">
          <mat-label>Truck Owner Number</mat-label>
        </div>
        <div class="col-sm-3">
          <mat-form-field>
            <input
              matInput
              formControlName="truckowner_number"
              placeholder="Enter Truck Owner No"
              readonly
            />
            <mat-error>Please Enter Truck Owner Number</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row align-items-center mtb">
        <div class="col-sm-3">
          <mat-label>Do Quantity</mat-label>
        </div>
        <div class="col-sm-3">
          <mat-form-field>
            <input
              matInput
              appThreeDigitDecimalNumber
              formControlName="do_quantity"
              placeholder="Enter DO QTY"
              (focusout)="remainingQnty($event)"
              required
            />
            <mat-error>Please Enter Do quantity</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row align-items-center mtb">
        <div class="col-sm-3">
          <mat-label>Price Per Ton</mat-label>
        </div>
        <div class="col-sm-3">
          <mat-form-field>
            <input
              matInput
              appTwoDigitDecimaNumber
              formControlName="price_per_ton"
              placeholder="Enter Price Per Ton"
              required
            />
            <mat-error>Please Enter Price Per Ton</mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-3">
          <mat-label>Sales Order Number</mat-label>
        </div>
        <div class="col-sm-3">
          <mat-form-field>
            <input
              matInput
              formControlName="sales_order_no"
              placeholder="Enter Sales Order Number"
              required
              appAlphanumericOnly
              toUppercase
              maxlength="16"
            />
            <mat-error>Please Enter Sales Order Number</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row align-items-center" *ngIf="showRadioButtons">
        <div class="col-sm-6">
          <p>Payment will be done as per:</p>
        </div>
        <div class="col-sm-6">
          <mat-radio-group
            aria-label="Select an option"
            formControlName="pay_as_load_quantity"
          >
            <mat-radio-button
              value="1"
              *ngIf="!isUnloadedQuantitySelected"
              (change)="selectLoadedQty('loaded_quantity')"
              >Loaded Quantity</mat-radio-button
            >
            <mat-radio-button
              value="2"
              *ngIf="!isLoadedQuantitySelected"
              (change)="selectLoadedQty('unloaded_quantity')"
              class="radio_btn"
              >Unloaded Quantity</mat-radio-button
            >
          </mat-radio-group>
        </div>
      </div>
    </div>
    <div class="row buttons">
      <div class="col-sm-2">
        <button
          type="submit"
          class="button buttonBlue"
          [class.spinner]="loading"
          [ngClass]="{ 'button-disabled': loading || !doTruckOwnerForm.valid }"
          [disabled]="loading"
          (click)="doTruckowner($event)"
        >
          Submit
        </button>
      </div>
    </div>
  </div>
</form>
